import { render, staticRenderFns } from "./ReportDetailModal.vue?vue&type=template&id=4903fe12&scoped=true&"
import script from "./ReportDetailModal.vue?vue&type=script&lang=js&"
export * from "./ReportDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetailModal.vue?vue&type=style&index=0&id=4903fe12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4903fe12",
  null
  
)

export default component.exports